{
  "de": {
    "nav": {
      "home": "Startseite",
      "back": "Zurück",
      "navigation": "Navigation",
      "ships": {
        "index": "Schiffe"
      },
      "compare": {
        "index": "Vergleichen",
        "ships": "Schiffe Vergleichen"
      },
      "manufacturers": "Hersteller",
      "images": "Bilder",
      "videos": "Videos",
      "hangar": {
        "index": "Mein Hangar",
        "vehicleLoadouts": "Loadouts"
      },
      "login": "Anmelden",
      "logout": "Abmelden",
      "apiV1": "API v1",
      "apiV1Schema": "Schema",
      "apiV1Pagination": "Paginierung",
      "authApiV1": "Auth API v1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schema",
      "embed": "Einbettungswidget",
      "signUp": "Registrieren",
      "privacyPolicy": "Datenschutzerklärung",
      "impressum": "Impressum",
      "fleets": {
        "index": "Flotten",
        "add": "Neue Flotte erstellen",
        "invites": "Einladungen",
        "ships": "Schiffe",
        "members": {
          "index": "Mitglieder",
          "invites": "Einladungen",
          "worldmap": "Weltkarte",
          "starmap": "Sternenkarte"
        },
        "stats": "Statistiken",
        "logistics": {
          "index": "Logistics"
        },
        "settings": {
          "index": "Einstellungen",
          "fleet": "Flotteneinstellungen",
          "membership": "Mitgliedschaftseinstellungen",
          "roles": "Rollen"
        }
      },
      "rsiProfile": "RSI-Profil",
      "rsiHangar": "RSI-Hangar",
      "tools": {
        "index": "Werkzeuge",
        "travelTimes": "Reisezeiten",
        "cargoGrids": "Frachtgitter"
      },
      "api": "API-Dokumentation",
      "stats": "Statistiken",
      "toggleSlimCollapse": "Zusammenklappen",
      "toggleSlimExpand": "Erweitern",
      "roadmap": {
        "index": "Roadmap",
        "overview": "Übersicht",
        "changes": "Änderungen",
        "ships": "Schiffe-Roadmap"
      },
      "rsiVerification": "RSI-Verifizierung",
      "settings": {
        "index": "Einstellungen",
        "profile": "Profil",
        "account": "Konto",
        "security": "Sicherheit",
        "notifications": "Benachrichtigungen",
        "hangar": "Hangar",
        "features": "Funktionen",
        "connections": "Verbindungen",
        "oauthApplications": "OAuth-Apps",
        "verify": "RSI-Kontoverifizierung"
      },
      "reload": "Update verfügbar!",
      "visualTests": {
        "index": "Visuelle Tests",
        "panels": "Bereiche",
        "buttons": "Schaltflächen",
        "tables": "Tabellen",
        "notifications": "Benachrichtigungen",
        "syncModal": "Sync-Modal",
        "supportHint": "Support-Hinweis"
      },
      "admin": {
        "index": "Admin",
        "models": {
          "index": "Modelle",
          "create": "Modell erstellen",
          "edit": {
            "index": "Basisdaten",
            "metrics": "Metriken",
            "prices": "Preise",
            "docks": "Andockplätze",
            "modules": "Module",
            "paints": "Lackierungen",
            "images": "Bilder",
            "videos": "Videos",
            "cargoAndFuel": "Fracht und Treibstoff",
            "cargoHolds": "Frachträume",
            "fleetchart": "Flottenkarten-Bilder",
            "hardpoints": "Aufhängungspunkte",
            "loaners": "Leihschiffe",
            "upgrades": "Upgrades",
            "packages": "Pakete"
          }
        },
        "modelPaints": {
          "index": "Lackierungen",
          "create": "Lackierung erstellen"
        },
        "modelModules": {
          "index": "Module",
          "create": "Modul erstellen",
          "edit": {
            "index": "Basisdaten",
            "models": "Modelle",
            "prices": "Preise"
          }
        },
        "modelModulePackages": {
          "index": "Modulpakete",
          "create": "Modulpaket erstellen"
        },
        "components": {
          "index": "Komponenten",
          "edit": {
            "index": "Basisdaten",
            "prices": "Preise"
          }
        },
        "manufacturers": {
          "index": "Hersteller"
        },
        "images": {
          "index": "Bilder"
        },
        "users": {
          "index": "Benutzer",
          "edit": "Bearbeiten",
          "fleets": "Flotten"
        },
        "fleets": {
          "index": "Flotten"
        },
        "vehicles": {
          "index": "Fahrzeuge"
        },
        "admins": {
          "index": "Administratoren"
        },
        "oauthApplications": {
          "index": "OAuth-Apps"
        },
        "maintenance": {
          "index": "Wartung",
          "pghero": "PG-Hero",
          "features": "Funktionen",
          "workers": "Worker",
          "tasks": "Aufgaben",
          "imports": "Importe",
          "rsiApiStatus": "RSI-API-Status"
        },
        "supporterContributions": {
          "index": "Unterstützer-Beiträge",
          "new": "Neuer Beitrag",
          "edit": "Beitrag bearbeiten"
        },
        "fundingGoals": {
          "index": "Finanzierungsziele",
          "new": "Neues Finanzierungsziel",
          "edit": "Finanzierungsziel bearbeiten"
        }
      }
    }
  }
}
